<template>
    <div class="container-fluid">
      <div class="block-header">
      </div>
      <div class="row clearfix">
        <div class="col-lg-12 col-md-12">
          <div class="card">
            <div class="align-items-center body d-flex flex-column flex-md-row justify-content-center">
              <p class="font-18 mb-0 mb-5 mb-md-0 w-50">
                <strong class="d-block font-24"> 🚧 Under Construction 🚧</strong>
                  <br />
                  Oh, hello there! You've caught us in the middle of our behind-the-scenes magic. We're giving our website a bit of a tune-up to ensure it continues to work smoothly and efficiently for you. 
                  <br />
                  <br />

                  Not to worry, though. We'll be back online before you know it! Your patience is much appreciated as we improve our digital spaces to serve you better.
                  <br />
                  <br />

                  In the meantime, why not take a moment to disconnect and enjoy the world around you? After all, the best ideas come when you least expect them.
                  <br />
                  <br />

                  See you soon! Thanks for your understanding and support.
                  <br />
                  <br />

                  Best,
                  Angel Communities Team
              </p>
              <img src="@/assets/images/not-data.svg" width="500" alt="" class="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: "MaintenanceComponent",
    components: {
    },
    mounted() {
      document.getElementById('left-sidebar').style.display = 'none';
      document.getElementById('main-content').style.margin = '0';
      document.getElementById('main-content').style.width = '100%';
      document.getElementById('footer').style.margin = '0';
      document.getElementById('footer').style.width = '100%';
      document.getElementsByClassName('navbar-fixed-top')[0].style.display = 'none';
    }
  };
  </script>
  
  